import { ActionOverRecordTypes, triggerAction, IActionsSchema, ZendraLocalizationServices, FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { HarvestBlockService, PlanTypeService, PropertyService } from 'cbd-proxies';

FieldBuilder.setNamespace('Operational');

export const LOADPLAN_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('planVersion', 'Entity.LoadPlan.PlanVersion')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .date('startDate', 'Entity.LoadPlan.StartDate')
    .required()
    .build(),
  FieldBuilder
    .number('volume', 'Entity.LoadPlan.Volume')
    .required()
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'planTypeId',
    'Entity.PlanType',
    PlanTypeService
  )
    .required()
    .display('name')
    .displayFromNested('planTypeName')
    .sortBy('planTypeName')
    .keyField('id')
    .readOnly()
    .showReadOnlyInForm()
    .build(),
  FieldBuilder.foreignKey(
    'harvestBlockId',
    'Entity.HarvestBlock',
    HarvestBlockService
  )
    .required()
    .display('name')
    .displayFromNested('harvestBlockName')
    .sortBy('harvestBlockName')
    .keyField('id')
    .build(),
  FieldBuilder
    .number('versionId', 'Entity.LoadPlan.VersionId')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'propertyId',
    'Entity.Property',
    PropertyService
  )
    .display('name')
    .displayFromNested('propertyName')
    .sortBy('propertyName')
    .readOnly()
    .build(),
];

export const ACTION_IDS = {
  importExcelModal: 0,
  downloadExcelTemplateTrigger: 1,
} as const;

export const LOAD_PLAN_ACTION_IDS = ACTION_IDS;

export const LOADPLAN_ACTIONS: IActionsSchema = {
  overTable: [
    triggerAction(
      ACTION_IDS.importExcelModal,
      'Action:ExcelImport',
      ActionOverRecordTypes.OverTable,
      ZendraLocalizationServices.LanguageService,
    ),
    triggerAction(
      ACTION_IDS.downloadExcelTemplateTrigger,
      'Actions:ExcelTemplateDownload',
      ActionOverRecordTypes.OverTable,
      ZendraLocalizationServices.LanguageService,
    )
  ],
};

export const LOAD_PLAN_ACTIONS_CONFIG = LOADPLAN_ACTIONS;

export const LOADPLAN_CONFIG = {
  entityName: 'LoadPlan',
  localizationKey: 'Operational::Entity.LoadPlan',
  fields: LOADPLAN_FIELDS,
  permission: 'PlanningOperation.LoadPlans',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.PlanningOperational + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Load + MENU_NAME_SUFFIX,
  actions: LOAD_PLAN_ACTION_IDS,
  actionIds: ACTION_IDS,
};
